import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted } from 'vue'
import TaskTimeShow from '@/views/dashboard/_components/task-time/task-time-show.vue'
import { StrategyListData } from '@/views/dashboard/policy/process-control/process-control.service'
import ProcessList from '@/views/dashboard/policy/process-control/_components/process-list/process-list.vue'
import { PermissionFe } from '@/services/service-permission.service'
import { PolicyType } from '@/views/dashboard/_enum/policy-type'
import PolicyManage from '@/views/dashboard/_components/policy-manage/policy-manage.vue'
import ProcessControlEdit from '@/views/dashboard/policy/process-control-edit/process-control-edit.vue'
import { TableOptColumn } from '@/components/cmTable/types'
import ItemGroup from '@/views/_components/item-group/item-group.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'process-control',
  setup(__props) {

const activeRow = ref({} as StrategyListData)
const softwareListVisible = ref(false)
const policyManageRef = ref()
const policyEditDrawerVisible = ref(false)
const policyEditPolicyId = ref('')

function handlePolicyAction ({ type, rowItem }: { type: string; rowItem?: StrategyListData }) {
  if (type === 'add' || type === 'edit') {
    policyEditPolicyId.value = type === 'edit' ? rowItem?.id ?? '' : ''
    policyEditDrawerVisible.value = true
  }
}

function onPolicyEditSuccess () {
  policyEditDrawerVisible.value = false
  policyManageRef.value?.tableRef?.getList()
}

// 动态添加类名以设置父容器高度
onMounted(() => {
  const routerViewWrap = document.querySelector('.router-view-wrap')
  if (routerViewWrap) {
    routerViewWrap.classList.add('process-control-page')
  }
})

onUnmounted(() => {
  const routerViewWrap = document.querySelector('.router-view-wrap')
  if (routerViewWrap) {
    routerViewWrap.classList.remove('process-control-page')
  }
})

const customCols: TableOptColumn[] = [
  {
    label: '控制进程',
    prop: 'data_count',
    columnOpt: { minWidth: 120, },
  },
  {
    label: '执行时间',
    prop: 'strategy.frequency',
    columnOpt: { minWidth: 160, },
  },
]

function showSoftList(item: StrategyListData) {
  activeRow.value = item
  softwareListVisible.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PolicyManage, {
      ref_key: "policyManageRef",
      ref: policyManageRef,
      style: {"height":"100%"},
      "normal-permission-key": _unref(PermissionFe).proc_control,
      "strategy-type": _unref(PolicyType).processControl,
      "custom-cols": customCols,
      "edit-in-drawer": "",
      "log-route": "/dashboard/process-control-log",
      "log-btn-text": "查看程序进程日志",
      onHandleAction: handlePolicyAction
    }, {
      table__data_count: _withCtx((scope) => [
        _createVNode(ItemGroup, {
          onClick: ($event: any) => (showSoftList(scope.row)),
          tooltip: false,
          data: scope.row.strategy.process_infos.map(v => v.name)
        }, null, 8, ["onClick", "data"])
      ]),
      "table__strategy.frequency": _withCtx((scope) => [
        _createVNode(TaskTimeShow, {
          frequency: scope.row.strategy.frequency,
          "task-time": scope.row.strategy.regular_tasks
        }, null, 8, ["frequency", "task-time"])
      ]),
      _: 1
    }, 8, ["normal-permission-key", "strategy-type"]),
    _createVNode(ProcessList, {
      modelValue: softwareListVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((softwareListVisible).value = $event)),
      "policy-name": activeRow.value.name,
      "process-list": activeRow.value.strategy?.process_infos || []
    }, null, 8, ["modelValue", "policy-name", "process-list"]),
    _createVNode(_component_el_drawer, {
      modelValue: policyEditDrawerVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((policyEditDrawerVisible).value = $event)),
      title: "策略编辑",
      size: "75%",
      "destroy-on-close": "",
      direction: "rtl"
    }, {
      default: _withCtx(() => [
        (policyEditDrawerVisible.value)
          ? (_openBlock(), _createBlock(ProcessControlEdit, {
              key: 0,
              "drawer-mode": "",
              "initial-policy-id": policyEditPolicyId.value,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (policyEditDrawerVisible.value = false)),
              onSuccess: onPolicyEditSuccess
            }, null, 8, ["initial-policy-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})